// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__SrAOy","signatureButtonsRight":"ModalSign_signatureButtonsRight__2VRRt"};